<template>
  <div>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Filter"
      />
    </v-card-title>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          dark
          absolute
          top
          right
          @click.stop="onCreate"
          v-on="on"
        >
          <v-icon>note_add</v-icon>
        </v-btn>
      </template>
      <span>Create new Legal Entity</span>
    </v-tooltip>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          dark
          absolute
          top
          left
          @click.stop="refresh"
          v-on="on"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <span>Refresh</span>
    </v-tooltip>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
      :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            {{ props.item.id }}
          </td>
          <td>
            {{ props.item.company_name }}
          </td>
          <td>
            {{ props.item.company_type }}
          </td>
          <td>
            {{ props.item.country }}
          </td>
          <td>
            {{ props.item.postal_code }}
          </td>
          <td>
            {{ props.item.city }}
          </td>
          <td>
            {{ props.item.street }}
          </td>
          <td>
            {{ props.item.street_no }}
          </td>
          <td class="text-xs">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="() => onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="error"
                  v-on="on"
                  @click.stop="() => showDeleteDialog(props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <CreateDialog
      v-if="isCreating"
      :is-open="isCreating"
      :item="currentItem"
      :toggle-open="onCreate"
    />

    <DeleteDialog
      key="delete_dialog"
      :visible="isDeleteDialogActive()"
      :legal-entity-id="currentDeleteItem"
      @close="hideDeleteDialog()"
      @submit="onDelete()"
    />

    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :auto-height="true"
    >
      <ul v-if="snackbarErrors">
        <li
          v-for="snackbarError in snackbarErrors"
          :key="snackbarError.message"
        >
          {{ snackbarError.message }}
        </li>
      </ul>

      <div
        v-if="snackbarMessage"
      >
        {{ snackbarMessage }}
      </div>

      <v-btn
        color="primary"
        text
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DeleteDialog from '@/components/payoutsAndTaxes/payout/dialogs/legalEntity/DeleteDialog';
import CreateDialog from '@/components/payoutsAndTaxes/payout/dialogs/legalEntity/CreateDialog';

export default {
  name: 'LegalEntities',
  components: {
    CreateDialog,
    DeleteDialog,
  },
  data() {
    return {
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      selected: 0,
      currentItem: {},
      currentDeleteItem: '',
      isLoading: false,
      isCreating: false,
      isShowing: false,
      isEditing: false,
      deleteDialogs: {},
      pagination: {
        rowsPerPage: 25,
      },
      search: '',
      headers: [
        { text: 'ID', value: 'id:' },
        { text: 'Company Name', value: 'company_name' },
        { text: 'Company Type', value: 'company_type' },
        { text: 'Country', value: 'country' },
        { text: 'Postal Code', value: 'postal_code' },
        { text: 'City', value: 'city' },
        { text: 'Street', value: 'street' },
        { text: 'Street No', value: 'street_no' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  computed: {
    payoutPendingApprovals() {
      return this.$store.getters.getLegalEntitiesList;
    },
    filteredItems() {
      const { search } = this;

      return search.length < 1 ?
        this.payoutPendingApprovals :
        this.payoutPendingApprovals.filter((item) => {
          let found = false;
          Object.keys(item)
            .map((key) => {
              if (item[key] && String(item[key]).toLowerCase().indexOf(search.toLowerCase()) > -1) {
                found = true;
              }

              return key;
            });

          return found;
        });
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    onCreate() {
      this.isCreating = !this.isCreating;
      this.currentItem = {};
    },
    onEdit(item) {
      this.isCreating = !this.isCreating;
      this.currentItem = item;
    },
    onDelete() {
      this.$store.dispatch('deletePatLegalEntity', this.currentDeleteItem)
        .then(() => {
          this.snackbarShow = true;
          this.snackbarErrors = [];
          this.snackbarMessage = 'Legal Entity Deleted!';
          this.snackbarColor = 'success';
        })
        .catch((error) => {
          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
    isDeleteDialogActive() {
      return this.deleteDialog;
    },
    showDeleteDialog(id) {
      this.currentDeleteItem = id;
      this.deleteDialog = true;
      this.$forceUpdate();
    },
    hideDeleteDialog() {
      this.deleteDialog = false;
      this.$forceUpdate();
    },
    refresh() {
      this.$store.dispatch('fetchPatLegalEntityAll');
    },
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/LegalEntities.vue